export default "__VITE_ASSET__8_dQOiU7__"